import { useState } from "react";
import { SendCsvFileAdminGrop } from "../../faetures/fetch";


export default function SendFile ({p=false, className, send_file}) {
    const [fileName, setFileName] = useState('בחר קובץ');
    const [file, setFile] = useState();

    function selectFile (e) {
        if (e.target.files[0]) {
            setFileName(e.target.files[0]['name']);
            setFile(e.target.files[0]);
        }
    }

    function sendFile () {
        file && SendCsvFileAdminGrop(file, fileName).then((resolve) => {
            if (send_file) {
                send_file(resolve);
            }
        })
    }

    return (
        <div className={className ? className : "grop-admin-setting-send-file"}>
            {p && <p>  עדכון קובץ </p>}
            <label>
                <input type={'file'} name={'file'} onChange={(e) => selectFile(e)} />
                <span> {fileName} </span>
            </label>

            <p onClick={() => sendFile()}> שלח </p>
        </div>
    )
}